import { render, staticRenderFns } from "./Muelles.vue?vue&type=template&id=70d9311e"
import script from "./Muelles.vue?vue&type=script&lang=js"
export * from "./Muelles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports